const currencyTypeSymbols = {
    'aud': '&#36;',
    'cad': '&#36;',
    'eur': '&#128;',
    'gbp': '&#163;',
    'rub': 'руб',
    'usd': '&#36;',
    'jpy': '&#165;'
};

function getCurrencyTypeSymbol(currencyType) {
    if (currencyTypeSymbols.hasOwnProperty(currencyType)) {
        return currencyTypeSymbols[currencyType];
    }
    return '?';
}

export default {
    'getCurrencySymbol': (currencyType) => {
        return getCurrencyTypeSymbol(currencyType);
    }
};